export default __webpack_public_path__ + "static/media/fauna-index-checkbox.d291b4f3.png";